import React, { useState, useEffect } from 'react';
import { Grid, Typography, Switch, Box, Button, Card, CardContent } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { useGetSettingsQuery, useUpdateSettingsMutation } from 'state/api';
import { useSnack, SaveSnackbar } from './settingsHelper';

const DeliveryRestriction = () => {
  const { data } = useGetSettingsQuery();
  const settings = data?.data || {};
  const [updateSettings, { isLoading }] = useUpdateSettingsMutation();
  const { snack, showSuccess, showError, closeSnack } = useSnack();

  const [deliveryAvailableCountry, setDeliveryAvailableCountry] = useState(false);
  const [deliveryAvailableZipCodeArea, setDeliveryAvailableZipCodeArea] = useState(false);

  useEffect(() => {
    const d = settings.custom?.deliveryRestriction;
    if (!d) return;
    if (d.deliveryAvailableCountry !== undefined) setDeliveryAvailableCountry(d.deliveryAvailableCountry);
    if (d.deliveryAvailableZipCodeArea !== undefined) setDeliveryAvailableZipCodeArea(d.deliveryAvailableZipCodeArea);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const handleDeliveryAvailableCountryChange = (event) => {
    setDeliveryAvailableCountry(event.target.checked);
  };

  const handleDeliveryAvailableZipCodeAreaChange = (event) => {
    setDeliveryAvailableZipCodeArea(event.target.checked);
  };

  const handleSave = async () => {
    try {
      await updateSettings({
        custom: { deliveryRestriction: { deliveryAvailableCountry, deliveryAvailableZipCodeArea } },
      }).unwrap();
      showSuccess();
    } catch (err) {
      showError(err?.data?.error?.message);
    }
  };

  return (
    <Card variant="outlined" sx={{ borderColor: 'divider', bgcolor: 'background.paper' }}>
      <CardContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h6" color="text.primary" sx={{ display: 'flex', alignItems: 'center' }}>
              <ShoppingCartIcon sx={{ mr: 1, color: 'primary.main' }} /> Delivery
              <InfoIcon color="primary" />
            </Typography>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography variant="body1" color="text.primary">Deliver to available country</Typography>
              <Switch checked={deliveryAvailableCountry} onChange={handleDeliveryAvailableCountryChange} />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography variant="body1" color="text.primary">Deliver to available zip code area</Typography>
              <Switch checked={deliveryAvailableZipCodeArea} onChange={handleDeliveryAvailableZipCodeAreaChange} />
            </Box>
          </Grid>

          <Grid item xs={12}>
            <Button variant="contained" color="primary" onClick={handleSave} disabled={isLoading}>
              {isLoading ? 'Saving...' : 'Save'}
            </Button>
          </Grid>
        </Grid>

        <SaveSnackbar snack={snack} onClose={closeSnack} />
      </CardContent>
    </Card>
  );
};

export default DeliveryRestriction;
